module.exports = __webpack_public_path__ + "img/DJ.1e2947e7.png";